module.exports = {
	"ha": "fha",
	"id": 5.3,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2022 Q1–2023 Q4",
		"lastYear": "2023",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Fraser Health by Age Category, Year Ending 2023 Q4 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -165,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "62%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "62%",
				"height": "38%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 80.8695652173913,
						"dataLabels": {
							"enabled": true,
							"format": "93",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.8695652173913,
						"dataLabels": {
							"enabled": true,
							"format": "93",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.8695652173913,
						"dataLabels": {
							"enabled": true,
							"format": "93",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 70.43478260869566,
						"dataLabels": {
							"enabled": true,
							"format": "81",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": true,
							"format": "69",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 96.03960396039604,
						"dataLabels": {
							"enabled": true,
							"format": "291",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 92.4092409240924,
						"dataLabels": {
							"enabled": true,
							"format": "280",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 89.10891089108911,
						"dataLabels": {
							"enabled": true,
							"format": "270",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 79.86798679867987,
						"dataLabels": {
							"enabled": true,
							"format": "242",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 63.6963696369637,
						"dataLabels": {
							"enabled": true,
							"format": "193",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.92241379310344,
						"dataLabels": {
							"enabled": true,
							"format": "459",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 93.31896551724138,
						"dataLabels": {
							"enabled": true,
							"format": "433",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 91.16379310344827,
						"dataLabels": {
							"enabled": true,
							"format": "423",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.62068965517241,
						"dataLabels": {
							"enabled": true,
							"format": "388",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 64.87068965517241,
						"dataLabels": {
							"enabled": true,
							"format": "301",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.75549048316252,
						"dataLabels": {
							"enabled": true,
							"format": "1349",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 93.55783308931186,
						"dataLabels": {
							"enabled": true,
							"format": "1278",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 92.09370424597365,
						"dataLabels": {
							"enabled": true,
							"format": "1258",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 87.18887262079062,
						"dataLabels": {
							"enabled": true,
							"format": "1191",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 72.10834553440702,
						"dataLabels": {
							"enabled": true,
							"format": "985",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -19.130434782608695,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.903225806451612,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.814814814814813,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -3.960396039603964,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.7800687285223344,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.370370370370374,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -20.24793388429752,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.0775862068965525,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.664488017429193,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -2.3094688221709014,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.274231678486998,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -22.422680412371133,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.2445095168374776,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -1.5649452269170583,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.325914149443555,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -17.29638958858103,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=115"
			},
			{
				"x": 9,
				"text": "30–39<br>n=303"
			},
			{
				"x": 15,
				"text": "40–49<br>n=464"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=1366"
			}
		],
		"dataTable": {
			"< 30": [
				115,
				93,
				93,
				93,
				81,
				69
			],
			"30–39": [
				303,
				291,
				280,
				270,
				242,
				193
			],
			"40–49": [
				464,
				459,
				433,
				423,
				388,
				301
			],
			"≥ 50": [
				1366,
				1349,
				1278,
				1258,
				1191,
				985
			]
		}
	},
	"callback": "C:\\Git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_fha_5_3.json
// module id = 202
// module chunks = 0